define("shared/components/shared/post/secondary/hashtag-suggestions/tabs", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul
    class="o--nav--underline u--row u--row--noCollapse u--text--center u--m__lr__0 u--m__b"
    data-test-id="ui-hashtag-suggestions-tabs"
  >
    {{#each @tabValues as |tab|}}
      <li class="o--nav__item u--col__6 u--p__lr__0">
        <Shared::Ui::Button
          @onClick={{fn @setCurrentTab tab}}
          @variant="unstyled"
          class={{concat-classes @qaClass "o--nav__link o--btn--block" (if (eq @currentTab tab) "is--active")}}
          {{on "click" (fn @trackTabClick tab)}}
        >
          {{t (concat "hashtag_suggestions.tab." tab)}}
        </Shared::Ui::Button>
      </li>
    {{/each}}
  </ul>
  */
  {
    "id": "ZSyoKyeh",
    "block": "[[[10,\"ul\"],[14,0,\"o--nav--underline u--row u--row--noCollapse u--text--center u--m__lr__0 u--m__b\"],[14,\"data-test-id\",\"ui-hashtag-suggestions-tabs\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,1]],null]],null],null,[[[1,\"    \"],[10,\"li\"],[14,0,\"o--nav__item u--col__6 u--p__lr__0\"],[12],[1,\"\\n      \"],[8,[39,2],[[16,0,[28,[37,3],[[30,3],\"o--nav__link o--btn--block\",[52,[28,[37,5],[[30,4],[30,2]],null],\"is--active\"]],null]],[4,[38,7],[\"click\",[28,[37,6],[[30,6],[30,2]],null]],null]],[[\"@onClick\",\"@variant\"],[[28,[37,6],[[30,5],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,8],[[28,[37,9],[\"hashtag_suggestions.tab.\",[30,2]],null]],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[2]],null],[13]],[\"@tabValues\",\"tab\",\"@qaClass\",\"@currentTab\",\"@setCurrentTab\",\"@trackTabClick\"],false,[\"each\",\"-track-array\",\"shared/ui/button\",\"concat-classes\",\"if\",\"eq\",\"fn\",\"on\",\"t\",\"concat\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/tabs.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});